import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Dropdown from '../../components/ui/DropDown';
import CourseCard from '../../components/CourseCard/CourseCard'; 
import './Programs.css'; 
import { Programs as ProgramsEN, Program } from '../../data/programs';
import { Programs as ProgramsRU } from '../../data/ruprograms';

const ProgramsPage: React.FC = () => {
  const { t, i18n } = useTranslation();

  // Select correct programs data
  const Programs = i18n.language === 'ru' ? ProgramsRU : ProgramsEN;

  // Define category values in English
  const categoryOptions = [
    { value: 'All Categories', label: t('all_categories') },
    { value: 'Literature', label: t('literature') },
    { value: 'Architecture', label: t('architecture') },
    { value: 'History', label: t('history') },
    { value: 'Culture', label: t('culture') },
  ];

  // Store only the English value in state
  const [category, setCategory] = useState<string>('All Categories');
  const [date, setDate] = useState<string>('December 2024');

  // Helper to get the translated label for a given value
  const getCategoryLabel = (value: string) => {
    const found = categoryOptions.find(option => option.value === value);
    return found ? found.label : '';
  };

  // Filter programs by category (English value)
  let filteredPrograms: Program[] = category === 'All Categories'
    ? Programs
    : Programs.filter((program) => program.category === category);

  // Sort programs by start date
  filteredPrograms = filteredPrograms.sort(
    (a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
  );

  return (
    <div className="courses-page">
      <div className="courses-page-header">
        <div className="ctitle-container-courses">
          <h1 className="programs-title">{t('programs_title')}</h1>
          <h1 className="courses-subtext">{t('programs_subtext')}</h1>
        </div>

        <div className="courses-filters">
          <Dropdown
            label={t('category')}
            // Show translated labels in the dropdown
            options={categoryOptions.map(option => option.label)}
            // Convert the stored English value to a translated label
            selectedOption={getCategoryLabel(category)}
            onChange={(selectedLabel) => {
              // Convert the label back to English value
              const option = categoryOptions.find(opt => opt.label === selectedLabel);
              if (option) setCategory(option.value);
            }}
          />

          {/* <Dropdown
            label={t('date')}
            options={['December 2024', 'January 2025', 'February 2025']}
            selectedOption={date}
            onChange={setDate}
          /> */}
        </div>
      </div>

      <div className="courses-list">
        {filteredPrograms.length > 0 ? (
          filteredPrograms.map((program) => (
            <CourseCard
              key={program.id}
              image={program.image}
              date={program.dateRange}
              title={program.title}
              description={program.description}
              learnMoreLink={`/program/${program.id}`} 
               masters={program.Masters} mastersLink={''}            />
          ))
        ) : (
          <p>{t('no_programs_available')}</p>
        )}
      </div>
    </div>
  );
};

export default ProgramsPage;
